import axios from 'axios';

/** 조회 조건을 고정한 채 서버 total 기준으로 모든 페이지를 가져온다. */
export async function fetchManualPaymentExportRows(baseUrl, params) {
  const filters = { ...params };
  const limit = 100;
  const rows = [];
  let pageCount = 1;

  for (let page = 1; page <= pageCount; page += 1) {
    const { data } = await axios.get(baseUrl + '/api/cp/payment/manual', {
      params: { ...filters, page, limit },
      withCredentials: true,
      timeout: 30000,
    });
    if (data?.code !== 1000 || !Array.isArray(data?.data?.rows)) {
      throw new Error('결제내역을 조회하지 못했습니다. 다시 다운로드해 주세요.');
    }
    if (page === 1) {
      const total = Number(data.data.total);
      if (data.data.total == null || !Number.isSafeInteger(total) || total < 0) {
        throw new Error('전체 결제내역 건수를 확인하지 못했습니다. 다시 다운로드해 주세요.');
      }
      pageCount = Math.ceil(total / limit);
    }
    rows.push(...data.data.rows);
  }

  return rows;
}
